import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactComponent as MenuCloseDisableSvg } from 'assets/menuCloseDisable.svg';

const MenuCloseDisableIcon: React.FC<SvgIconProps> = (props) => {
  return <SvgIcon {...props} component={MenuCloseDisableSvg} />;
};

export default MenuCloseDisableIcon;
